module.exports = __webpack_public_path__ + "img/person.95baad37.jpg";